import { createRouter, createWebHashHistory, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import ChatView from '@/views/ChatView.vue'
import SignInView from '@/views/SignInView.vue'
import RegisterView from '@/views/RegisterView.vue'
import RequestView from '@/views/RequestView.vue'
import SubscribeView from '@/views/SubscribeView.vue'
import AdminView from '@/views/AdminView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: HomeView
  },
  {
    path: '/stonks',
    name: 'Stonks',
    component: ChatView
  },
  {
    path: '/sign-in',
    name: 'Sign In',
    component: SignInView
  },
  {
    path: '/register',
    name: 'Register',
    component: RegisterView
  },
  {
    path: '/request',
    name: 'Request Access',
    component: RequestView
  },
  {
    path: '/subscribe',
    name: 'Subscribe',
    component: SubscribeView
  },
  {
    path: '/admin',
    name: 'Admin',
    component: AdminView
  }
  // {
  //   path: "/about",
  //   name: "about",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  // }
]

const router = createRouter({
  // history: process.env.IS_ELECTRON ? createWebHashHistory() : createWebHistory(process.env.BASE_URL),
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
